import { Component, ViewEncapsulation } from "@angular/core";
import { AbstractComponent } from "../abstract-component/abstract.component";
import { AppService } from "../app.service";
import { ServiceLocator } from "../service-locator";
import { Router, NavigationEnd, UrlTree } from "@angular/router";
import { BaseDataType } from "../base-data-type";
import { trigger, transition, style, animate } from "@angular/animations";
import { LabelType } from "../label-type";
import { ConfDataType } from "../conf-data-type";

type DrawerState = "opened" | "closed";

@Component({
    selector: "app-help-drawer",
    templateUrl: "./help-drawer.component.html",
    styleUrls: ["./help-drawer.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger(
            "fadeInfadeOut", [
                transition(":enter", [
                    style({ opacity: 0 }),
                    animate("300ms", style({ opacity: 1 }))
                ]),
                transition(":leave", [
                    style({ opacity: 1 }),
                    animate("300ms", style({ opacity: 0 }))
                ])
            ]
        )
    ]
})
export class HelpDrawerComponent extends AbstractComponent {

    public readonly TAG: string = "[HelpDrawerComponent]";

    private typeId: string;
    private subtypeId: string;

    public state: DrawerState;

    public currentType: BaseDataType;

    private navSectionTypeById: { [key: string]: BaseDataType };

    private router: Router;

    public drawerTitleLabel: LabelType;

    // Store requested object's values here
    public confData: ConfDataType;

    constructor() {
        super();

        this.router = ServiceLocator.injector.get(Router);

        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe(this.navigationEventHandler.bind(this));
    }

    protected navigationEventHandler(e: NavigationEnd = null): void {
        console.log(this.TAG, this.router.url, this.router.parseUrl(this.router.url));
        const urlTree: UrlTree = this.router.parseUrl(this.router.url);
        if (urlTree.root.children.primary.segments.length < 2) {
            return;
        }

        this.lang = urlTree.root.children.primary.segments[1] ? urlTree.root.children.primary.segments[1].path : undefined;
        this.typeId = urlTree.root.children.primary.segments[2] ? urlTree.root.children.primary.segments[2].path : undefined;
        this.subtypeId = urlTree.root.children.primary.segments[3] ? urlTree.root.children.primary.segments[3].path : undefined;

        if (this.navSectionTypeById === undefined) { return; }

        this.currentType = this.navSectionTypeById[this.subtypeId ? this.subtypeId : this.typeId];        

        if(
            this.confDataService.confdata[this.subtypeId] &&
            this.confDataService.confdata[this.subtypeId].values &&
            this.confDataService.confdata[this.subtypeId].values[0] &&
            this.navSectionTypeById[this.confDataService.confdata[this.subtypeId].values[0]]
        ) {
            this.currentType = this.navSectionTypeById[this.confDataService.confdata[this.subtypeId].values[0]];
        }

        this.confDataService.observable.subscribe(
            (value) => {
                if(value.id == this.subtypeId) {
                    if(this.navSectionTypeById[value.values[0]]) {
                        this.currentType = this.navSectionTypeById[value.values[0]];
                    } else {
                        this.currentType = this.navSectionTypeById[this.subtypeId ? this.subtypeId : this.typeId];
                    }
                }
            }
        );
    }

    public switchState(): void {
        this.state = this.state === "opened" ? "closed" : "opened";
    }

    ngOnInit() {
        super.ngOnInit();

        this.state = "opened";
    }

    public getData(): void {
        super.getData();

        console.log(this.TAG, "getData()");

        this.appService.getLabel("help-drawer-title")
        .then(label => {this.drawerTitleLabel = label; console.log(label); });

        this.appService.getData(AppService.NAVIGATION_MENU_URL)
            .then(types => {
                this.navSectionTypeById = {};
                for (const type of types) {
                    this.navSectionTypeById[type.id] = type;
                    for (const value of type.values) {
                        this.navSectionTypeById[value.id] = value;
                        if(value.values) {
                            for (const subValue of value.values) {
                                this.navSectionTypeById[subValue.id] = subValue;
                            }
                        }
                    }
                }
                this.navigationEventHandler();
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/help-drawer/help-drawer.component.ts